import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const activityCategoryKeys = {
  all: ['activity-categories'],
  tree: () => [...activityCategoryKeys.all, 'tree'],
  list: (filters) => [...activityCategoryKeys.all, 'list', filters],
};
